import React from "react";
import { EmailLayoutContainer } from "../../../containers";

const EmailLayout = (props) => {
  return <EmailLayoutContainer {...props} />;
};

export default EmailLayout;
